import { node } from 'prop-types'

const NoData = ({ children }) => (
  <div className="nodata_wrap">
    <p className="inner_nodata">{children}</p>
  </div>
)
NoData.propTypes = {
  children: node,
}
export default NoData
